/* CRTD Chrome — drawer toggling + header scroll border.
   Spec §4.2–4.4. Loaded via layout/theme.liquid as defer asset. */
(function () {
  'use strict';

  const doc = document;
  let returnFocusEl = null;

  // ---------- Focus trap via inert ----------
  function setBodyInert(panel, backdrop, on) {
    const children = Array.from(doc.body.children);
    children.forEach((el) => {
      if (el === panel || el === backdrop) return;
      if (on) el.setAttribute('inert', '');
      else el.removeAttribute('inert');
    });
  }

  // ---------- Drawer open/close ----------
  function openPanel(name) {
    returnFocusEl = doc.activeElement;
    const panel = doc.querySelector(`[data-crtd-panel="${name}"]`);
    const backdrop = doc.querySelector(`[data-crtd-backdrop="${name}"]`);
    if (!panel) return;
    panel.setAttribute('data-open', 'true');
    panel.setAttribute('aria-hidden', 'false');
    if (backdrop) backdrop.setAttribute('data-open', 'true');
    doc.body.style.overflow = 'hidden';
    setBodyInert(panel, backdrop, true);
    if (name === 'search') {
      const input = panel.querySelector('[data-crtd-search-input]');
      if (input) setTimeout(() => input.focus(), 200);
    }
  }

  function closePanel(name) {
    const panel = doc.querySelector(`[data-crtd-panel="${name}"]`);
    const backdrop = doc.querySelector(`[data-crtd-backdrop="${name}"]`);
    if (!panel) return;
    panel.setAttribute('data-open', 'false');
    panel.setAttribute('aria-hidden', 'true');
    if (backdrop) backdrop.setAttribute('data-open', 'false');
    doc.body.style.overflow = '';
    setBodyInert(panel, backdrop, false);
    if (returnFocusEl) { returnFocusEl.focus(); returnFocusEl = null; }
  }

  function closeAll() { ['menu', 'search', 'cart'].forEach(closePanel); }

  doc.addEventListener('click', (e) => {
    const openTarget = e.target.closest('[data-crtd-open]');
    if (openTarget) {
      e.preventDefault();
      closeAll();
      openPanel(openTarget.getAttribute('data-crtd-open'));
      return;
    }
    const closeTarget = e.target.closest('[data-crtd-close]');
    if (closeTarget) {
      e.preventDefault();
      closePanel(closeTarget.getAttribute('data-crtd-close'));
    }
  });

  doc.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeAll();
  });

  // ---------- Header scroll border ----------
  const header = doc.querySelector('[data-crtd-header]');
  if (header) {
    let ticking = false;
    function updateHeader() {
      const scrolled = window.scrollY > 8;
      header.setAttribute('data-scrolled', scrolled ? 'true' : 'false');
      ticking = false;
    }
    updateHeader();
    window.addEventListener('scroll', () => {
      if (!ticking) {
        requestAnimationFrame(updateHeader);
        ticking = true;
      }
    }, { passive: true });
  }

  // ---------- Announcement dismiss ----------
  const ann = doc.querySelector('[data-crtd-ann]');
  if (ann) {
    const KEY = 'crtd-ann-dismissed';
    if (sessionStorage.getItem(KEY) === '1') {
      ann.setAttribute('data-dismissed', 'true');
    }
    const closeBtn = ann.querySelector('[data-crtd-ann-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', () => {
        ann.setAttribute('data-dismissed', 'true');
        sessionStorage.setItem(KEY, '1');
      });
    }
  }
})();
